import {
    IonButton,
    IonCard,
    IonCardContent,
    IonContent,
    IonHeader,
    IonInput,
    IonLoading,
    IonPage,
    IonText,
    IonTitle,
    IonToolbar
} from "@ionic/react";
import {useEffect, useState} from "react";
import {Link, useHistory} from 'react-router-dom'
import createAxiosInstance from '../../services/AxiosInstance';

import { useToast } from "../../utils/useToasts";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {initializeSession, setToken} from "../../store/slices/authSlice";
import './AuthPages.css';

const MIN_USERNAME_LENGTH = 4;
const MIN_PASSWORD_LENGTH = 8;
const CREATED_STATUS = 201;

const Register: React.FC = () => {
    const history = useHistory();
    const [busy, setBusy] = useState<boolean>(false);
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("")
    const [passwordConfirm, setPasswordConfirm] = useState("")
    const axios = createAxiosInstance();
    const showToasts = useToast();
    const dispatch = useAppDispatch();
    const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

    useEffect(() => {
        if (isAuthenticated) {
            history.push('/');
        }
    }, [history, isAuthenticated]);

    async function register() {
        try {
            setBusy(true);
            await performRegister(username, email, password, passwordConfirm);
        } catch (e) {
            console.error(e)
        } finally {
            setBusy(false);
        }
    }

    const isValidEmail = (candidate: string) => /\S+@\S+\.\S+/.test(candidate);

    const performRegister = async (username: string, email: string, password: string, passwordConfirm: string) => {
        const trimmedUsername = username.trim();
        const trimmedEmail = email.trim();

        if(password !== passwordConfirm) {
            showToasts("Wachtwoorden komen niet overeen!", 'danger')
            return
        }
        if (trimmedUsername.length === 0 || trimmedEmail.length === 0 || password.length === 0 || passwordConfirm.length === 0) {
            showToasts("Niet alle velden ingevuld", "danger")
            return
        }
        if (!isValidEmail(trimmedEmail)) {
            showToasts('Voer een geldig e-mailadres in', 'danger')
            return
        }
        if (trimmedUsername.length < MIN_USERNAME_LENGTH) {
            showToasts('Gebruikers naam te kort', 'danger')
            return
        }
        if (password.length < MIN_PASSWORD_LENGTH || passwordConfirm.length < MIN_PASSWORD_LENGTH) {
            showToasts('Wachtwoord te kort', 'danger')
            return
        }
        const registerBody = {
            username: trimmedUsername,
            email: trimmedEmail,
            password
        }
        try {
            const res = await axios.post(`/auth/register`, registerBody)
            if (res.status === CREATED_STATUS) {
                showToasts('Succesvol geregistreerd!', 'success')
                dispatch(setToken(res.data.accessToken));
                dispatch(initializeSession());
                history.push('/welkom')
            }
        } catch (err) {
            console.error(err);
            showToasts('Registratie onsuccesvol', 'danger')
            throw err;
        }
    }


    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Registreer</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonLoading message="Please wait.." duration={0} isOpen={busy}/>
            <IonContent className="ion-padding auth-page">
                <div className="auth-wrapper">
                    <IonCard className="auth-card">
                        <IonCardContent>
                            <div className="auth-heading">
                                <h1>Maak een account</h1>
                                <IonText color="medium">
                                    <p>Registreer met gebruikersnaam, e-mail en wachtwoord.</p>
                                </IonText>
                            </div>
                            <form
                                className="auth-form"
                                onSubmit={(event) => {
                                    event.preventDefault();
                                    if (!busy) {
                                        register();
                                    }
                                }}
                            >
                                <IonInput
                                    fill="outline"
                                    label="Gebruikersnaam"
                                    labelPlacement="stacked"
                                    placeholder="Minimaal 4 tekens"
                                    value={username}
                                    autocomplete="username"
                                    onIonInput={(e) => setUsername(e.detail.value ?? "")}
                                />
                                <IonInput
                                    type="email"
                                    fill="outline"
                                    label="E-mailadres"
                                    labelPlacement="stacked"
                                    placeholder="naam@voorbeeld.nl"
                                    value={email}
                                    autocomplete="email"
                                    onIonInput={(e) => setEmail(e.detail.value ?? "")}
                                />
                                <IonInput
                                    type="password"
                                    fill="outline"
                                    label="Wachtwoord"
                                    labelPlacement="stacked"
                                    placeholder="Minimaal 8 tekens"
                                    value={password}
                                    autocomplete="new-password"
                                    onIonInput={(e) => setPassword(e.detail.value ?? "")}
                                />
                                <IonInput
                                    type="password"
                                    fill="outline"
                                    label="Bevestig wachtwoord"
                                    labelPlacement="stacked"
                                    placeholder="Herhaal je wachtwoord"
                                    value={passwordConfirm}
                                    autocomplete="new-password"
                                    onIonInput={(e) => setPasswordConfirm(e.detail.value ?? "")}
                                />
                                <IonButton
                                    expand="block"
                                    type="submit"
                                    disabled={busy || !username.trim() || !email.trim() || !password.trim() || !passwordConfirm.trim()}
                                >
                                    Registreer
                                </IonButton>
                            </form>
                            <div className="auth-links">
                                <p>Al een account? <Link to="/login">Login</Link></p>
                            </div>
                        </IonCardContent>
                    </IonCard>
                </div>
            </IonContent>
        </IonPage>
    );
}

export default Register;
